import React, { useEffect, useState } from "react";
import { getFileStream } from "@/api/client.ts";
import { aiApi } from "@/api/aiApi.ts";
import TypewriterMarkdown from "@/components/TypewriterMarkdown";
import { PdfView } from "@/components/pdfView";
import { XMarkIcon } from "@heroicons/react/16/solid";
import type { SearchDocument } from "@/types";
import { HoverTip } from "@/components/hoverTip";
import { useTranslation } from "@/locales";
import { useIsMobile } from "@/hooks/use-mobile";

interface ViewFileProps {
  open?: boolean;
  type: string;
  onClose: () => void;
  record?: SearchDocument;
  className?: string;
  index?: number;
}

interface MarkdownData {
  title: string;
  content: string;
}

export const ViewFile: React.FC<ViewFileProps> = ({ className = "", open, type, onClose, record, index }) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const [url, setUrl] = useState<string>("");
  const [markDown, setMarkDown] = useState<MarkdownData | null>({
    title: "",
    content: "",
  });
  const [sheetAnimation, setSheetAnimation] = useState<"entering" | "entered" | "exiting" | "exited">("exited");
  const [visible, setVisible] = useState(false);
  const [currentFileId, setCurrentFileId] = useState<string | number | undefined>(undefined); // 新增状态保存当前请求的fileId

  const fetchData = async () => {
    console.log(record);
    if (!record?.fileId) return;
    if (record.fileId === currentFileId) return; // 如果fileId相同，不重新请求
    console.log("currentFileId", currentFileId);
    setCurrentFileId(record.fileId); // 更新当前请求的fileId

    console.log(record.fileId);
    if (type == "PDF") {
      getFileStream(`/v1/knowledge/file/pdf/content`, {
        fileId: record?.fileId,
      }).then((blob) => {
        changeVisible();
        console.log(blob);
        const objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
        console.log(objectUrl);
      });
    } else {
      aiApi.conversation
        .getMarkdownFile(record?.fileId)
        .then((res) => {
          changeVisible();
          setMarkDown(res as MarkdownData);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  const handleSheetClose = () => {
    setSheetAnimation("exiting");
    setTimeout(() => {
      setSheetAnimation("exited");
      setVisible(false);
      onClose?.();
    }, 300);
  };
  const changeVisible = () => {
    setVisible(true);
    setSheetAnimation("entering");
    setTimeout(() => setSheetAnimation("entered"), 100);
  };
  useEffect(() => {
    console.log("record", record);
    if (open) {
      fetchData();
      setVisible(true);
      setSheetAnimation("entering");
      setTimeout(() => setSheetAnimation("entered"), 100);
    } else if (visible) {
      handleSheetClose();
    }
  }, [open, record?.fileId, type]);

  useEffect(() => {
    console.log("Record changed", record);
  }, [record?.fileId]);

  // useEffect(() => {
  //     if (open) {
  //         fetchData();

  //     } else if (visible) {
  //         handleSheetClose();
  //     }
  // }, [open, record, type, visible, onClose]);
  const handleClose = () => {
    handleSheetClose();
  };

  return open ? (
    <div className={`view-file border-s ${sheetAnimation}  ${className} rounded-r-[16px]`}>
      <div className={"flex flex-col flex-1 h-full"}>
        <div className={type != "PDF" ? "h-12" : "hidden"}>
          <div className="close-btn">
            <button
              className="text-token-text-secondary hover:bg-[#e8e8e8] rounded-lg h-[32px] w-[32px] mr-1 flex items-center justify-center"
              onClick={handleClose}>
              <XMarkIcon className="w-[22px] h-[22px]"></XMarkIcon>
            </button>
          </div>
        </div>
        {type === "PDF" ? (
          <div className={"h-full flex-1 overflow-y-auto"}>
            <PdfView file={url} record={record} initialPage={index} isClose={true} onClose={handleClose}></PdfView>
            {/*<iframe src={`${url}#page=${index}&toolbar=1&scrollbar=0`} className={'w-full h-full'}></iframe>*/}
          </div>
        ) : (
          markDown && (
            <div className={"h-full flex-1 pb-[60px]"}>
              <div className="header" style={{ padding: "12px 12px" }}>
                <div
                  className={
                    "text-left  title text-[14px] font-medium text-[var(--s-color-text-primary)] h-[36px] leading-[36px]"
                  }>
                  <div className={"text-s-color-text-primary s-font-small-strong box-border w-[400px]"}>
                    {isMobile ? (
                      <div className="px-[4px] truncate-1-lines  w-fit max-w-full flex items-center justify-start rounded-[4px] cursor-pointer select-none">
                        {markDown.title}
                      </div>
                    ) : (
                      <HoverTip content={markDown.title}>
                        <div className="px-[4px] truncate-1-lines  w-fit max-w-full flex items-center justify-start rounded-[4px] cursor-pointer select-none hover:u-hover-show-parent-CigIit">
                          {markDown.title}
                        </div>
                      </HoverTip>
                    )}
                  </div>
                </div>
              </div>
              <div className={"p-[12px] h-full flex-1 overflow-y-auto min-h-[100vh]"}>
                <div className={"answer-content mb-5"}>
                  <TypewriterMarkdown content={markDown.content}></TypewriterMarkdown>
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  ) : (
    ""
  );
};
